import {
	WORKEDON_TAB_KEY,
	VIEWED_TAB_KEY,
	ASSIGNED_TAB_KEY,
	STARRED_TAB_KEY,
	BOARDS_TAB_KEY,
} from '../common/constants/tab-content.tsx';
import type { TabConfig } from '../common/types/tabs.tsx';
import AssignedToMeTab from './tabs/assigned-to-me/index.tsx';
import { BoardsTab } from './tabs/boards/BoardsTab.tsx';
import RecentlyViewedTab from './tabs/recently-viewed/index.tsx';
import StarredTab from './tabs/starred/index.tsx';
import WorkedOnTab from './tabs/worked-on/index.tsx';

// Provider must match the key of a service provider
// The id's are used for analytics tracking, as well as a machine name
// by the tabs navigation component.
// If you change them, you will break analytics.
// You can change what the user sees in the translation.
export const NAV_V3_TABS: TabConfig[] = [
	{
		id: WORKEDON_TAB_KEY,
		provider: 'WorkedOn',
		showCount: false,
		tabContent: WorkedOnTab,
	},
	{
		id: VIEWED_TAB_KEY,
		provider: 'RecentlyViewed',
		showCount: false,
		tabContent: RecentlyViewedTab,
	},
	{
		id: ASSIGNED_TAB_KEY,
		provider: 'AssignedToUser',
		showCount: true,
		tabContent: AssignedToMeTab,
	},
	{
		id: STARRED_TAB_KEY,
		provider: 'Favourites',
		showCount: false,
		tabContent: StarredTab,
	},
].filter(Boolean);

export const NAV_V4_TABS: TabConfig[] = [
	...NAV_V3_TABS,
	...[
		{
			id: BOARDS_TAB_KEY,
			provider: 'Boards',
			showCount: false,
			tabContent: BoardsTab,
		},
	].filter(Boolean),
];

export const MOBILE_WEB_TABS: TabConfig[] = [
	{
		id: WORKEDON_TAB_KEY,
		provider: 'WorkedOn',
		showCount: false,
		tabContent: WorkedOnTab,
	},
	{
		id: ASSIGNED_TAB_KEY,
		provider: 'AssignedToUser',
		showCount: true,
		tabContent: AssignedToMeTab,
	},
];

export const MOBILE_WEB_WITH_VIEWED_TABS: TabConfig[] = [
	...MOBILE_WEB_TABS,
	{
		id: VIEWED_TAB_KEY,
		provider: 'RecentlyViewed',
		showCount: false,
		tabContent: RecentlyViewedTab,
	},
];
